<nav>
  <ftl-quote-external-header *ngIf="isLoggedIn"></ftl-quote-external-header>
</nav>